import { render } from "./TableMetric.vue?vue&type=template&id=3f99e990"
import script from "./TableMetric.vue?vue&type=script&lang=js"
export * from "./TableMetric.vue?vue&type=script&lang=js"

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TableMetric.vue"]])

export default __exports__